import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import Announcementslider from "./Announcementslider";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../config/api";

function UserCandidateListView(prop) {
  const [data, setData] = useState(null);
  const location = useLocation();
  const { state } = location;
  const [userPermissions, setUserPermissions] = useState([]);
  const stateValue = location.state && location.state["userPermissions"];
  const [monthlyRecords, setMonthlyRecords] = useState([]);
  const [pipelineAndTurnedUp, setPipelineAndTurnedUp] = useState("null");
  const [name, setName] = useState("null");
  const [image, setImage] = useState("null");
  const [isNewSop, setIsNewSop] = useState(false);
  const [username, setUsername] = useState("null");
  const [id, setId] = useState("null");
  const [showModal, setShowModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [candidateList, setCandidateList] = useState([]);
  const navigate = useNavigate();
  const [userDefinedPermissions, setUserDefinedPermissions] = useState([]);


  // Sign Out Handler
  const handleSignOut = () => {
    localStorage.removeItem("access_token");
    navigate("/");
  };

  // Fetch User Data on Component Mount
  useEffect(() => {
    if (localStorage.getItem("access_token") !== null) {
      fetchUserData();
    }
    if (state && state.userPermissions) {
      setUserPermissions(state.userPermissions);
    }
  }, []);

  // Fetch Updated User Data
  const fetchUserData = async () => {
    try {
      const response = await fetch(
        getApiUrl("/GetUserDatafromUsernameOfAllCandidate/"),
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      console.log("API Response:", data); // Log the full API response
      setId(data.records.id);
      setData(data.records);
      setName(data.records.name);
      setImage(data.records.image);
      setUsername(data.records.username);
      setCandidateList(data.all_entry); // Ensure this contains updated revenue
      setMonthlyRecords(data.monthly_records);
      setPipelineAndTurnedUp(data.pipelineandturnedup[0].pipeline);

      const storedPermissions2 =
        JSON.parse(localStorage.getItem("user_defined_permissions")) || [];
      setUserDefinedPermissions(storedPermissions2);

      // Check for new SOP
      if (Array.isArray(data.sop) && data.sop.length > 0) {
        const sopData = data.sop[0];
        if (sopData.updated_date) {
          const updatedDate = new Date(sopData.updated_date)
            .toISOString()
            .split("T")[0];
          const currentDate = new Date().toISOString().split("T")[0];
          const diffInTime = new Date(currentDate) - new Date(updatedDate);
          const diffInDays = diffInTime / (1000 * 3600 * 24);
          setIsNewSop(diffInDays >= 0 && diffInDays <= 2);
        }
      } else {
        setIsNewSop(false);
      }
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
    }
  };

  // Open Modal for Creating New Entry
  const openCreateModal = () => {
    setSelectedRecord(null);
    setShowModal(true);
  };

  // Open Modal for Editing Candidate Details
  const openEditModal = (record) => {
    setSelectedRecord(record);
    setShowModal(true);
  };

  // Close Modal
  const closeModal = () => {
    setShowModal(false);
    setSelectedRecord(null);
  };

  // Handle Record Creation or Update
  const handleSave = async () => {
    try {
      const formData = new FormData();
      console.log("Hello: ", id);
      formData.append("id", id);

      if (selectedRecord) {
        console.log("Hi");
        // Edit existing record
        console.log("Candidate ID: ", selectedRecord.id);
        formData.append("candidate_id", selectedRecord.id);
        formData.append("candidate_name", selectedRecord.candidate_name);
        formData.append("speciality", selectedRecord.speciality);
        formData.append("hospital", selectedRecord.hospital);
        formData.append("city", selectedRecord.city);
        formData.append("state", selectedRecord.state);
        formData.append(
          "remark",
          document.getElementById("remark").value || "No remarks"
        );
        formData.append("user_rec", id);
        formData.append("status", document.getElementById("status").value);
        formData.append("expected_revenue", document.getElementById("expected_revenue").value);
        formData.append("revenue", document.getElementById("revenue").value);
      } else {
        console.log("Create New record");
        // Create new record
        formData.append(
          "candidate_name",
          document.getElementById("candidateName").value
        );
        formData.append(
          "speciality",
          document.getElementById("speciality").value
        );
        formData.append("hospital", document.getElementById("hospital").value);
        formData.append("city", document.getElementById("city").value);
        formData.append("state", document.getElementById("state").value);
        formData.append(
          "remark",
          document.getElementById("remark").value || "No remarks"
        );
        formData.append("status", document.getElementById("status").value);
        formData.append("expected_revenue", document.getElementById("expected_revenue").value);
        formData.append("revenue", document.getElementById("revenue").value);
        formData.append("user_rec", id);

        // Append image if uploading a new one
        const imageInput = document.getElementById("image");
        if (imageInput && imageInput.files.length > 0) {
          formData.append("image", imageInput.files[0]);
        }
      }

      const url = getApiUrl(API_ENDPOINTS.UPDATE_RECORD);
      const method = "PUT";
      const response = await fetch(url, {
        method,
        body: formData,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to save record");
      }

      const responseData = await response.json();
      closeModal();
      fetchUserData(); // Refresh data after saving
    } catch (error) {
      console.error("Error saving record:", error);
      alert("Failed to save record. Please try again.");
    }
  };

  // Helper function to determine text color based on status (optional)
  const getTextColor = (status) => {
    switch (status) {
      case "resume_forwarded":
        return "#007bff"; // Dark Blue
      case "pipeline":
        return "#ffc107"; // Gold
      case "turned_up":
        return "#28a745"; // Green
      case "selected":
        return "#007bff"; // Dark Blue
      default:
        return "#000000"; // Default Black
    }
  };

  // Confirm and Delete Candidate Record
  const confirmDelete = (candidateId) => {
    if (
      window.confirm("Are you sure you want to delete this candidate record?")
    ) {
      fetch(getApiUrl(`/Candidatedetail/${candidateId}/delete/`), {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": getCookie("csrftoken"), // Include CSRF token for security
          "Authorization": `Bearer ${localStorage.getItem("access_token")}`,
        },
      })
        .then((response) => {
          if (response.ok) {
            // Remove the row from the DOM
            setCandidateList((prevList) =>
              prevList.filter((record) => record.id !== candidateId)
            );
            alert("Record deleted successfully.");
            fetchUserData();
          } else {
            return response.json().then((data) => {
              alert(`Error: ${data.detail || "Failed to delete record."}`);
            });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          alert("An unexpected error occurred while deleting the record.");
        });
    }
  };

  // Helper function to get CSRF token from cookies
  const getCookie = (name) => {
    let cookieValue = null;
    if (document.cookie && document.cookie !== "") {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.substring(0, name.length + 1) === name + "=") {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  };

  return (
    <>
      <section>
        {/* Navigation Bar */}

        <nav className="navbar navbar-expand-lg navbar-light bg-light" style={{ padding: "10px 20px" }}>
          <div style={{ display: "flex", gap: "15px", alignItems: "center", flexWrap: "wrap" }}>
            <button
              onClick={() => openCreateModal()}
              className="bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white px-4 py-2 rounded-md font-semibold transition-all shadow-md hover:shadow-lg"
            >
              ➕ Upload New Candidate
            </button>
            <Link
              to="/UserViews"
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md font-semibold transition-all"
            >
              📊 My Dashboard
            </Link>
            <Link to="/training" className="text-gray-700 hover:text-blue-600 font-medium">
              📚 Training
            </Link>
            <Link to="/oldrecordentry" className="text-gray-700 hover:text-blue-600 font-medium">
              📅 Old Month Record Update
            </Link>
          </div>

          {userDefinedPermissions.includes("Commitments") && (
            <Link
              to="/CommitmentList"
              className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-700 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
            >
              Commitments
            </Link>
          )}

          {userDefinedPermissions.includes("Team Leaders") && (
            <Link
              to="/teamleaderview"
              className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-700 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
            >
              Team Leaders
            </Link>
          )}
          <Link
            to="/UserCandidateListView"
            className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-700 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
          >
            Candidate List
          </Link>
          <Link
            className="signOutLink"
            to={{ pathname: "/" }}
            onClick={handleSignOut}
          >
            <i className="fa-solid fa-right-from-bracket"></i>
          </Link>
        </nav>


        {/* Candidate Details Table */}
        <h2 className="text-center  mt-4">Candidate Details</h2>
        <div style={{ marginTop: "15px" }}>
          <table
            className="min-w-full bg-white border border-gray-300"
            style={{ width: "95%", margin: "auto" }}
          >
            <thead>
              <tr>
                <th scope="col" className="py-2 px-4 border-b">
                  #
                </th>
                <th scope="col" className="py-2 px-4 border-b">
                  Candidate
                </th>
                <th scope="col" className="py-2 px-4 border-b">
                  Speciality
                </th>
                <th scope="col" className="py-2 px-4 border-b">
                  Hospital
                </th>
                <th scope="col" className="py-2 px-4 border-b">
                  City
                </th>
                <th scope="col" className="py-2 px-4 border-b">
                  State
                </th>
                <th scope="col" className="py-2 px-4 border-b">
                  Exp. Revenue
                </th>
                <th scope="col" className="py-2 px-4 border-b">
                  Revenue
                </th>
                <th scope="col" className="py-2 px-4 border-b">
                  Status
                </th>

                <th scope="col" className="py-2 px-4 border-b">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-300">
              {candidateList.map((record, index) => (
                <React.Fragment key={record.id}>
                  {/* Main Row */}
                  <tr>
                    <td className="py-2 px-4 border-b text-center">
                      {index + 1}
                    </td>
                    <td className="py-2 px-4 border-b text-center">
                      {record.candidate_name}
                    </td>
                    <td className="py-2 px-4 border-b text-center">
                      {record.speciality}
                    </td>
                    <td className="py-2 px-4 border-b text-center">
                      {record.hospital}
                    </td>
                    <td className="py-2 px-4 border-b text-center">
                      {record.city}
                    </td>
                    <td className="py-2 px-4 border-b text-center">
                      {record.state}
                    </td>
                    <td className="py-2 px-4 border-b text-center" style={{color: '#2563eb', fontWeight: 'bold'}}>
                      ₹{record.status === 'selected' ? ((parseFloat(record.expected_revenue) > 0 ? record.expected_revenue : record.revenue) || 0) : 0} lac
                    </td>
                    <td className="py-2 px-4 border-b text-center" style={{color: '#059669', fontWeight: 'bold'}}>
                      ₹{record.status === 'joined' ? (record.revenue || 0) : 0} lac
                    </td>
                    <td
                      className="py-2 px-4 border-b text-center"
                      style={{ color: getTextColor(record.status) }}
                    >
                      {record.status}
                    </td>
                    <td className="py-2 px-4 border-b text-center">
                      <button
                        className="btn btn-secondary m-1"
                        onClick={() =>
                          setExpandedRowId(
                            expandedRowId === record.id ? null : record.id
                          )
                        }
                      >
                        {expandedRowId === record.id
                          ? "Hide Details"
                          : "Show Details"}
                      </button>
                    </td>
                  </tr>

                  {/* Expanded Row */}
                  {expandedRowId === record.id && (
                    <tr style={{
                      backgroundColor: "#f8f9fa",
                    }}>
                      <td colSpan="10" className="py-2 px-4 border-b text-left">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                          }}
                        >
                          <p>
                            <strong>Remark:</strong> {record.remark || "N/A"}
                          </p>


                          <p>
                            <strong>Date Entered:</strong> {record.date_entered}
                          </p>
                          <div>
                            <button
                              className="btn btn-danger m-1"
                              onClick={() => confirmDelete(record.id)}
                            >
                              Delete
                            </button>
                            <button
                              className="btn btn-primary m-1"
                              onClick={() => openEditModal(record)}
                            >
                              Edit
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>

        {/* Modal for Creating or Editing Records */}
        {showModal && (
          <div
            className="fixed inset-0 flex justify-center items-center z-50"
            id="marketingmodalopen"
            style={{ width: "100vw", height: "100vh" }}
          >
            {/* <div className="absolute inset-0 bg-gray-800 bg-opacity-60 backdrop-blur-sm"></div> */}
            <div
              className="absolute inset-0 bg-gray-800 bg-opacity-60 backdrop-blur-sm"
              style={{
                width: "100vw",
                height: "150%",
                background: "black",
                backgroundSize: "200% 200vh",
                overflowY: "hidden",
                paddingBottom: "150px",
              }}
            ></div>
            <div
              className="relative bg-white  rounded-lg shadow-lg"
              style={{
                height: "95vh", // Set height to allow scrolling
                overflowY: "auto", // Enable scrolling inside modal
              }}
            >
              <div
                className="overflow-auto max-h-[80vh]"
                style={{
                  padding: "50px",
                  paddingTop: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <h2 className="text-center text-blue-700 mb-2">Add File</h2>
                <button
                  type="button"
                  className="btn btn-secondary m-2"
                  onClick={closeModal}
                >
                  X
                </button>
              </div>
              <form style={{ width: "50vw", height: "100%" }}>
                {selectedRecord ? (
                  <>
                    <div style={{ margin: "50px" }}>
                      <input
                        type="hidden"
                        id="candidateName"
                        value={selectedRecord.candidate_name}
                      />
                      <input
                        type="hidden"
                        id="speciality"
                        value={selectedRecord.speciality}
                      />
                      <input
                        type="hidden"
                        id="hospital"
                        value={selectedRecord.hospital}
                      />
                      <input
                        type="hidden"
                        id="city"
                        value={selectedRecord.city}
                      />
                      <input
                        type="hidden"
                        id="state"
                        value={selectedRecord.state}
                      />
                      <div className="mb-3">
                        <label htmlFor="status" className="form-label">
                          Status
                        </label>
                        <select
                          className="form-select"
                          id="status"
                          defaultValue={selectedRecord.status}
                        >
                          <option value="resume_forwarded">
                            Resume Forwarded
                          </option>
                          <option value="pipeline">Pipeline</option>
                          <option value="turned_up">Turned Up</option>
                          <option value="selected">Selected</option>
                          <option value="not_selected">Not Selected</option>
                          <option value="backout">Backout</option>
                          <option value="joined">Joined</option>
                        </select>
                      </div>
                      <div className="mb-3">
                        <label htmlFor="expected_revenue" className="form-label">
                          Expected Revenue
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="expected_revenue"
                          placeholder="Enter expected revenue"
                          defaultValue={selectedRecord.expected_revenue}
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="revenue" className="form-label">
                          Revenue
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="revenue"
                          placeholder="Enter revenue"
                          defaultValue={selectedRecord.revenue}
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="remark" className="form-label">
                          Remark
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="remark"
                          placeholder="Enter Remark"
                          defaultValue={selectedRecord.remark || ""}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div style={{ margin: "0 50px" }}>
                      <div className="mb-3">
                        <label htmlFor="candidateName" className="form-label">
                          Candidate Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          style={{ border: "1px solid #oeoeoe" }}
                          id="candidateName"
                          placeholder="Enter candidate name"
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="speciality" className="form-label">
                          Speciality
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="speciality"
                          placeholder="Enter speciality"
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="hospital" className="form-label">
                          Hospital
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="hospital"
                          placeholder="Enter hospital"
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="city" className="form-label">
                          City
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="city"
                          placeholder="Enter city"
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="state" className="form-label">
                          State
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="state"
                          placeholder="Enter state"
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="status" className="form-label">
                          Status
                        </label>
                        <select className="form-select" id="status">
                          <option value="resume_forwarded">
                            Resume Forwarded
                          </option>
                          <option value="pipeline">Pipeline</option>
                          <option value="turned_up">Turned Up</option>
                          <option value="selected">Selected</option>
                          <option value="not_selected">Not Selected</option>
                          <option value="backout">Backout</option>
                          <option value="joined">Joined</option>
                        </select>
                      </div>
                      <div className="mb-3">
                        <label htmlFor="expected_revenue" className="form-label">
                          Expected Revenue
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="expected_revenue"
                          placeholder="Enter expected revenue"
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="revenue" className="form-label">
                          Revenue
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="revenue"
                          placeholder="Enter revenue"
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="remark" className="form-label">
                          Remark
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="remark"
                          placeholder="Enter Remark"
                        />
                      </div>
                    </div>
                  </>
                )}
                {/* Buttons */}
                <div className="btncontainer">
                  <button
                    type="button"
                    className="btn btn-primary m-2"
                    onClick={handleSave}
                  >
                    Save Changes
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary m-2"
                    onClick={closeModal}
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </section>
    </>
  );
}

export default UserCandidateListView;
